var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-page__content-image"},[_c('AnimatedPlaceholder',{attrs:{"width":"100%","height":"210px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }